// Bridge for values that were previously attached to the Vue 2 constructor
// as static properties (Vue.x = ...) and accessed from store/service files
// outside component scope. Plugins populate this at init time; consumers
// import it directly instead of importing the Vue constructor.
const bridge = {
  triggerNewRelicEvent: null,
  googleEventTracking: null
};



export default bridge;
